import { useMemo } from 'react';

import {
  getDateByPeriodTypes,
  useMissionTimeLeft,
} from '@wwe-portal/ui/features/club-store/milestone/hooks/use-count-down-time-left';

export const useMilestone = ({
  data: { periodType = 1, currentPoint, updatedAt = Date.now() },
  onReset,
}: {
  data: {
    periodType?: number;
    currentPoint: number;
    endTime: string;
    updatedAt?: number;
  };
  onReset: () => void;
}) => {
  const { timeLeftText, now } = useMissionTimeLeft(periodType, onReset);
  const prevStartDate = useMemo(() => {
    return getDateByPeriodTypes(new Date(now), periodType, 0)?.getTime();
  }, [periodType, now]);

  const displayPoint: number =
    (prevStartDate ?? 0) < new Date(updatedAt).getTime() ? currentPoint : 0;

  const timeLeft = timeLeftText();

  return {
    timeLeft,
    displayPoint,
  };
};
